import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServicesOverview } from './components/ServicesOverview';
import { AboutStrip } from './components/AboutStrip';
import { LocationsServed } from './components/LocationsServed';
import { FaqStrip } from './components/FaqStrip';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { Parallax } from './components/Parallax';
export function App() {
  return <div className="min-h-screen bg-white font-body text-brand-text" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <ServicesOverview data-id="element-4" />

        {/* Parallax Band 1 */}
        <div className="relative" data-id="element-5">
          <Parallax image="https://cdn.magicpatterns.com/uploads/oW2TdS1yKwnML1y1PQLYWC/pool-1.png" height="300px" overlayColor="bg-brand-teal/70" data-id="element-6">
            <div className="container mx-auto px-6 text-center" data-id="element-7">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-8">
                Consistent care, week after week.
              </h2>
            </div>
          </Parallax>
        </div>

        <AboutStrip data-id="element-9" />

        <LocationsServed data-id="element-10" />

        {/* Parallax Band 2 */}
        <div className="relative" data-id="element-11">
          <Parallax image="https://cdn.magicpatterns.com/uploads/e8omrYRj7K2s4fPGUSxnTM/pool-2.png" height="300px" overlayColor="bg-brand-teal/80" data-id="element-12">
            <div className="container mx-auto px-6 text-center" data-id="element-13">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-14">
                Specialized treatments when you need them.
              </h2>
            </div>
          </Parallax>
        </div>

        <FaqStrip data-id="element-15" />

        <ContactSection data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}